import { BaseLayout, Notifications } from '@uag/react-core';

import { useGetInboxToken } from 'api/notifications/inbox/inbox';
import { useGetSenderImageHook } from 'api/notifications/messages/messages';
import { ProfileShell } from 'profile/shell/ProfileShell';

export const Home = () => {
    const { data: inboxToken, isLoading: isInboxTokenLoading } = useGetInboxToken({ provider: 'Novu' }, {
        query: { enabled: !!import.meta.env.VITE_APP_NOTIFICATIONS_API_URL },
    });
    const getSenderImage = useGetSenderImageHook();
    const getUserImageUrl = async (userId: string) => {
        const senderImageModel = await getSenderImage(userId);
        return senderImageModel?.data?.imageUri ?? undefined;
    };

    return (
        <BaseLayout
            innerClassName="grow overflow-auto text-base flex flex-col max-w-[1136px] text-text-default mx-auto"
            versionNumber={APP_VERSION}
        >
            <BaseLayout.HeaderItems>
                <Notifications
                    apiKey={inboxToken?.data?.publicApiKey ?? undefined}
                    getUserImageUrl={getUserImageUrl}
                    isLoading={isInboxTokenLoading}
                    userId={inboxToken?.data?.userIdentifier}
                    userToken={inboxToken?.data?.token}
                />
            </BaseLayout.HeaderItems>
            <BaseLayout.Content>
                <ProfileShell />
            </BaseLayout.Content>
        </BaseLayout>
    );
};
